'use client'

import Image from 'next/image'
import Link from 'next/link'

import { useState } from 'react'

import Breadcrumbs from '@/app/_components/Breadcrumbs'

const CategoryDiptychLegacy = ({category}) => {

    const [imageryLoaded, setImageryLoaded] = useState(false);

    return (
        <>
            <div className={`relative w-full h-auto aspect-[50/9]`}>
                <div className="absolute inset-0 bg-black/30 mix-blend-multiply z-[5]"></div>
                <Breadcrumbs breadcrumbs={category.breadcrumbs} on_white_background={false} className="absolute left-6 top-2 z-10" />
                <Image
                    priority={true}
                    src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/${category.diptych}`}
                    alt={category.category_name}
                    placeholder="blur"
                    blurDataURL="iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPcIgkAAYcAz3yXgHoAAAAASUVORK5CYII="
                    width={2500}
                    height={450}
                    onLoad={() => setImageryLoaded(true)}
                    sizes="(max-width: 768px) 100vw, (max-width: 1800px) 100vw"
                    className={`object-cover transition-opacity duration-700 ${imageryLoaded ? 'opacity-100' : 'opacity-0'}`}
                />
            </div>
        </>
    )
}

export default CategoryDiptychLegacy
